import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50ce00a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-menu-layout__content" }
const _hoisted_2 = { class: "tir-pm-menu-layout__top" }
const _hoisted_3 = { class: "tir-pm-menu-layout__bottom" }

import { TirPmScrollbar } from "tir-pm-scrollbar";

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-menu-layout',
  props: {
  /**Ширина */
  width: {
    type: String,
    default: "17.5rem",
  },
},
  setup(__props) {

const props = __props;


// #endregion defineProps

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tir-pm-menu-layout",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createVNode(_unref(TirPmScrollbar), {
      class: "tir-pm-menu-layout__scroll",
      "show-on-hover": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "top")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "bottom")
          ])
        ])
      ]),
      _: 3
    })
  ], 4))
}
}

})